import { LoginForm } from "@/components/modals/LoginForm";


export function LoginPage() {


	return (
		<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
			<title>Piher | Login</title>

			<div className="login content-box">
				<div style={{ textAlign: "center", padding: "30px 20px" }}>
					<img src="/img/logoAlmacen.svg" style={{ width: "auto" }} height="80px" />
				</div>

				<div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
					<div style={{ flex: 0.25 }} />
					<div className="form">
						<LoginForm />
					</div>
					<div style={{ flex: 0.75 }} />
				</div>

			</div>
		</div>
	);
}